// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js,json_types=true"
// @generated from file protobuf/journey/data/categories/marketplace_property_category.proto (package od_protos.journey.data.categories, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_protobuf_journey_data_options_options } from "../options/options_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/categories/marketplace_property_category.proto.
 */
export const file_protobuf_journey_data_categories_marketplace_property_category: GenFile = /*@__PURE__*/
  fileDesc("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", [file_protobuf_journey_data_options_options]);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategory = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory"> & {
  /**
   * @generated from oneof od_protos.journey.data.categories.MarketplacePropertyCategory.event
   */
  event: {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
     */
    value: MarketplacePropertyCategory_DetailPageViewEvent;
    case: "detailPageView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
     */
    value: MarketplacePropertyCategory_SimilarHomesClickEvent;
    case: "similarHomesClick";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
     */
    value: MarketplacePropertyCategory_TourBookingStartEvent;
    case: "tourBookingStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
     */
    value: MarketplacePropertyCategory_ReactionEvent;
    case: "reaction";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
     */
    value: MarketplacePropertyCategory_OfferStartEvent;
    case: "offerStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
     */
    value: MarketplacePropertyCategory_ShareEvent;
    case: "share";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
     */
    value: MarketplacePropertyCategory_RentalScamBannerViewEvent;
    case: "rentalScamBannerView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
     */
    value: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent;
    case: "rentalScamBannerLearnMore";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategoryJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
   */
  detailPageView?: MarketplacePropertyCategory_DetailPageViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
   */
  similarHomesClick?: MarketplacePropertyCategory_SimilarHomesClickEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
   */
  tourBookingStart?: MarketplacePropertyCategory_TourBookingStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
   */
  offerStart?: MarketplacePropertyCategory_OfferStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
   */
  share?: MarketplacePropertyCategory_ShareEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
   */
  rentalScamBannerView?: MarketplacePropertyCategory_RentalScamBannerViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
   */
  rentalScamBannerLearnMore?: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.
 * Use `create(MarketplacePropertyCategorySchema)` to create a new message.
 */
export const MarketplacePropertyCategorySchema: GenMessage<MarketplacePropertyCategory, {jsonType: MarketplacePropertyCategoryJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent.
 * Use `create(MarketplacePropertyCategory_DetailPageViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DetailPageViewEventSchema: GenMessage<MarketplacePropertyCategory_DetailPageViewEvent, {jsonType: MarketplacePropertyCategory_DetailPageViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent.
 * Use `create(MarketplacePropertyCategory_SimilarHomesClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SimilarHomesClickEventSchema: GenMessage<MarketplacePropertyCategory_SimilarHomesClickEvent, {jsonType: MarketplacePropertyCategory_SimilarHomesClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingStartEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingStartEvent, {jsonType: MarketplacePropertyCategory_TourBookingStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction: MarketplacePropertyCategory_ReactionEventReaction;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventReactionJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent.
 * Use `create(MarketplacePropertyCategory_ReactionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ReactionEventSchema: GenMessage<MarketplacePropertyCategory_ReactionEvent, {jsonType: MarketplacePropertyCategory_ReactionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent.
 * Use `create(MarketplacePropertyCategory_OfferStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferStartEventSchema: GenMessage<MarketplacePropertyCategory_OfferStartEvent, {jsonType: MarketplacePropertyCategory_OfferStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 4);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent.
 * Use `create(MarketplacePropertyCategory_ShareEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ShareEventSchema: GenMessage<MarketplacePropertyCategory_ShareEvent, {jsonType: MarketplacePropertyCategory_ShareEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 5);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerViewEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerViewEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 6);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 7);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export enum MarketplacePropertyCategory_ReactionEventReaction {
  /**
   * @generated from enum value: REACTION_UNSPECIFIED = 0;
   */
  REACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REACTION_ADD_LIKE = 1;
   */
  REACTION_ADD_LIKE = 1,

  /**
   * @generated from enum value: REACTION_REMOVE_LIKE = 2;
   */
  REACTION_REMOVE_LIKE = 2,

  /**
   * @generated from enum value: REACTION_ADD_DISLIKE = 3;
   */
  REACTION_ADD_DISLIKE = 3,

  /**
   * @generated from enum value: REACTION_REMOVE_DISLIKE = 4;
   */
  REACTION_REMOVE_DISLIKE = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export type MarketplacePropertyCategory_ReactionEventReactionJson = "REACTION_UNSPECIFIED" | "REACTION_ADD_LIKE" | "REACTION_REMOVE_LIKE" | "REACTION_ADD_DISLIKE" | "REACTION_REMOVE_DISLIKE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction.
 */
export const MarketplacePropertyCategory_ReactionEventReactionSchema: GenEnum<MarketplacePropertyCategory_ReactionEventReaction, MarketplacePropertyCategory_ReactionEventReactionJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

